import { cloneElement, isValidElement } from 'react';
import i18n from 'Services/i18n';

// Translates a modal button's textual props before it reaches ButtonGroup,
// so the collapsed "..." overflow menu - which reads these props directly
// instead of rendering the button - shows the same translated label as the visible button.
function translateButtonElement(node) {
    if (!isValidElement(node)) {
        return node;
    }

    const translatedProps = {};

    if (typeof node.props.altText === 'string') {
        translatedProps.altText = i18n(node.props.altText);
    }
    if (typeof node.props.text === 'string') {
        translatedProps.text = i18n(node.props.text);
    }
    if (typeof node.props.title === 'string') {
        translatedProps.title = i18n(node.props.title);
    }
    if (typeof node.props.children === 'string') {
        translatedProps.children = i18n(node.props.children);
    }

    if (isValidElement(node.props.reference)) {
        translatedProps.reference = translateButtonElement(node.props.reference);
    }

    return Object.keys(translatedProps).length > 0 ? cloneElement(node, translatedProps) : node;
}

export function translateButtonGroup(buttons) {
    if (Array.isArray(buttons)) {
        return buttons.map((entry) =>
            Array.isArray(entry) ? entry.map(translateButtonElement) : translateButtonElement(entry)
        );
    }

    return translateButtonElement(buttons);
}

export default translateButtonGroup;
